import React, { useState, useCallback } from 'react';
import Heading from '../components/Headers/Heading';
import CallToAction from '../components/Misc/CallToAction';

import BlogContainer from '../components/BlogComponents/BlogContainer';
import BlogPagination from '../components/BlogComponents/BlogPagination';
import BlogWidgetsContainer from '../components/BlogComponents/BlogWidgetsContainer';

function Bloglist() {
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 1,
        totalPages: 0,
        totalPosts: 0,
        hasMore: false
    });
    const [changePageFunction, setChangePageFunction] = useState(null);

    const handlePaginationChange = useCallback((info) => {
        setPaginationInfo(info);
    }, []);

    const handlePageChangeFunction = useCallback((changePageFn) => {
        setChangePageFunction(() => changePageFn);
    }, []);

    const handlePageChange = useCallback((pageNumber) => {
        if (changePageFunction) {
            changePageFunction(pageNumber);
        }
    }, [changePageFunction]);

    return (
        <>
            <Heading 
                heading={<h1 className="page-title">Recent activities</h1>}
                headingColumn="col-lg-8"
                WrapperComponent={(props) => {
                    return (
                        <div className="container page-header">
                            {props.children}
                        </div>
                    )
                }}
            />

            <div className="container sidebar-page">
                <div className="row ">

                    {/* first column - start */}
                    <div className="col-lg-8">
                        <div className="content-column right-sidebar">
                            <div className="page-content-wrapper">
                                <div className="blog-list">
                                    <div className="container">
                                        <BlogContainer 
                                            width="12" 
                                            postsPerPage={6}
                                            onPaginationChange={handlePaginationChange}
                                            onPageChange={handlePageChangeFunction}
                                        />
                                        <BlogPagination 
                                            currentPage={paginationInfo.currentPage}
                                            totalPages={paginationInfo.totalPages}
                                            onPageChange={handlePageChange}
                                            hasMore={paginationInfo.hasMore}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* first column - end */}
                    
                    {/* second column - start */}
                    <div className="col-lg-4 sidebar-column">
                        <div className="sidebar-column-wrapper">
                            <BlogWidgetsContainer/>
                        </div>
                    </div>
                    {/* second column - end */}

                </div>
            </div>

            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Love to join us? 
                        <br />
                        Volunteer with us now
                    </>
                }
                buttonText="Volunteer Now"
                buttonLink="/get-involved"
                buttonType="2"
                artwork={null}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default Bloglist;
